<template>
    <div>
        <button-tooltip :tooltip="$t('common.config')">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-on="on" v-bind="attrs" @click="showConfig">
                    <v-icon size="20" color="txtSecondary">mdi-cog-outline</v-icon>
                </v-btn>
            </template>
        </button-tooltip>

        <config-drawer :show-subscription-cancel="!!currentSubscription"
            @click:cancel-subscription="onSubscriptionCancelClick" @click:edit:personal-info="showEditPersonalInfo"
            @click:edit:professional-info="showEditProfessionalInfo" @click:select-plan="showSelectPlan"
            @click:delete-account="showDeleteAccount" ref="config" />

        <cancel-subscription v-if="currentSubscription" ref="cancelSubscription" :subscription="currentSubscription"
            @success="toSelectPlan" />

        <edit-personal-info-dialog ref="personalInfo" />
        <edit-professional-info-dialog ref="professionalInfo" />
        <select-plan-dialog ref="selectPlan" />

        <kimsa-confirm ref="deleteAccount" :title="$t('common.delete_account_title')"
            :content="$t('common.delete_account_subtitle')" :loading="loadingDelete" :persistent="false"
            @confirm="onConfirmDelete" :close-on-confirm="false" :alert-mode="true" />

    </div>
</template>

<script>

import ConfigDrawer from "@/components/coach/ConfigDrawer";
import CancelSubscription from "@/components/student/CancelSubscription";
import EditPersonalInfoDialog from '../EditPersonalInfoDialog.vue';
import KimsaConfirm from '../KimsaConfirm.vue';
import firebase from "@/utils/Firebase";
import EditProfessionalInfoDialog from '../EditProfessionalInfoDialog.vue';
import SelectPlanDialog from '@/components/coach/SelectPlanDialog';
import ButtonTooltip from '@/components/common/ButtonTooltip';

export default {
    components: {
        ButtonTooltip,
        CancelSubscription,
        ConfigDrawer,
        EditPersonalInfoDialog,
        KimsaConfirm,
        EditProfessionalInfoDialog,
        SelectPlanDialog,
    },
    data() {
        return {
            loadingDelete: false,
        }
    },
    computed: {
        currentSubscription() {
            const vm = this
            return vm.account
                && vm.account.stripeAccount
                && vm.account.stripeAccount.currentSubscription
        }
    },
    methods: {
        showConfig() {
            var vm = this
            vm.$refs.config.show()
        },
        hideConfig() {
            var vm = this
            vm.$refs.config.hide()
        },
        async hideConfigThen(showFn) {
            this.hideConfig()
            await new Promise(resolve => setTimeout(resolve, 300))
            showFn()
        },
        onSubscriptionCancelClick() {
            this.hideConfigThen(() => this.$refs.cancelSubscription.show())
        },
        toSelectPlan() {
            const vm = this
            vm.replaceRoute({ name: 'coach.select-plan' })
        },
        showEditPersonalInfo() {
            this.hideConfigThen(() => this.$refs.personalInfo.show())
        },
        showEditProfessionalInfo() {
            this.hideConfigThen(() => this.$refs.professionalInfo.show())
        },
        showSelectPlan() {
            this.hideConfigThen(() => this.$refs.selectPlan.show())
        },
        showDeleteAccount() {
            this.hideConfigThen(() => this.$refs.deleteAccount.show())
        },
        onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true
            vm.deleteAccount().catch(() => {})
            setTimeout(() => {
                vm.$refs.deleteAccount.hide()
                vm.loadingDelete = false
                vm.replaceRoute({ name: 'login' })
            }, 3000)
        },
        deleteAccount: firebase.functions().httpsCallable('httpPayments-deleteAccount'),
    },
}
</script>